<template>
  <MainContainer />
</template>

<script>
import MainContainer from "./containers/MainContainer.vue";
export default {
  name: "forgot-password",
  components: {
    MainContainer,
  },
};
</script>
